<template>
  <div v-loading.body="loading">
    <div class="c_page-title">
      <div>报销单支付列表</div>
    </div>
    <el-row class="filter">
      <el-col>
        <div
          style="
            background: #f3f3f3;
            height: 30px;
            line-height: 30px;
            padding: 0 25px;
            display: flex;
            align-items: center;
          "
        >
          <div>查询搜索</div>
          <el-button
            type="text"
            style="margin-left: auto"
            :icon="filterFold ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"
            @click="toggleFilter"
          >
            {{ filterFold ? "展开筛选" : "收起筛选" }}
          </el-button>
        </div>
        <el-collapse-transition>
          <div v-show="!filterFold">
            <div style="padding: 10px 25px">
              <el-form :inline="true" :model="form" class="demo-form-inline">
                <el-form-item>
                  <el-input
                    v-model="form.flow_code"
                    placeholder="报销单号"
                    @keyup.native.enter="search"
                  ></el-input>
                </el-form-item>
                <el-form-item>
                  <el-select
                    v-model="form.status"
                    placeholder="状态"
                    style="width: 150px"
                  >
                    <el-option label="全部" value="0"></el-option>
                    <el-option
                      v-for="item in statusArr"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-input
                    v-model="form.submitter_name"
                    placeholder="报销申请人"
                    @keyup.native.enter="search"
                  ></el-input>
                </el-form-item>
                <el-form-item>
                  <el-input
                    v-model="form.payer"
                    placeholder="支付人"
                  ></el-input>
                </el-form-item>
                <el-form-item>
                  <el-input
                    v-model="form.legal_entity"
                    placeholder="法人实体"
                  ></el-input>
                </el-form-item>
                <el-form-item label="待支付生成时间：">
                  <el-date-picker
                    v-model="form.create_time"
                    type="datetimerange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    :default-time="['00:00:00', '23:59:59']"
                  >
                  </el-date-picker>
                </el-form-item>
                <el-form-item label="支付时间：">
                  <el-date-picker
                    v-model="form.pay_time"
                    type="datetimerange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    :default-time="['00:00:00', '23:59:59']"
                  >
                  </el-date-picker>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="search">查询</el-button>
                  <el-button type="primary" @click="exportCsv">导出</el-button>
                </el-form-item>
              </el-form>
            </div>
          </div>
        </el-collapse-transition>
      </el-col>
    </el-row>
    <!-- 表格 -->
    <el-row>
      <el-col style="border: 1px solid #ddd">
        <div
          style="
            background: #f3f3f3;
            height: 50px;
            line-height: 30px;
            padding: 0 25px;
            display: flex;
            align-items: center;
          "
        >
          <div>数据列表：</div>
          <el-button
            style="margin-left: auto; background-color: coral"
            type="primary"
            size="mini"
            @click="updateStatus('pay')"
            >转账付款</el-button
          >
          <el-button
            slot="reference"
            style=""
            type="success"
            size="mini"
            @click="updateStatus('to_valid')"
            >激活</el-button
          >
          <el-button
            slot="reference"
            style=""
            type="success"
            size="mini"
            @click="updateStatus('to_invalid')"
            >作废</el-button
          >
        </div>
        <div style="margin-bottom: 0">
          <el-table
            v-if="resData"
            ref="multipleTable"
            v-loading="tableLoading"
            height="600"
            :data="resData.data"
            tooltip-effect="dark"
            style="width: 100%"
            @selection-change="handleSelectionChange"
          >
            <el-table-column
              align="center"
              type="selection"
              width="55"
              :selectable="checkboxInit"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="flow_title"
              label="标题"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="flow_code"
              label="报销单号"
            ></el-table-column>
            <!--                        <el-table-column align="center" prop="form_type" label="单据模板"></el-table-column>-->
            <el-table-column
              align="center"
              prop="submit_time"
              label="报销时间"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="submitter_name"
              label="报销申请人"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="cost_bearing_dept"
              label="费用承担部门"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="legal_entity"
              label="法人实体"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="pay_contact"
              label="收款人"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="pay_bank"
              label="收款银行"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="pay_branch"
              label="支行信息"
            ></el-table-column>

            <el-table-column
              align="center"
              prop="pay_account"
              label="收款人账号"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="amount"
              label="应付金额"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="create_time"
              label="待支付生成日期"
            ></el-table-column>
            <!--                        <el-table-column align="center" prop="flow_certificate" label="报销单凭证">-->
            <!--                            <template slot-scope="scope">-->
            <!--                            <div v-viewer style="width:40px;height:40px;overflow:hidden;cursor:pointer;margin: auto;" v-if="scope.row.flow_certificate">-->
            <!--                                <img  :src="scope.row.flow_certificate" alt="" style="width: 100%;height:100%;">-->
            <!--                            </div>-->
            <!--                            </template>-->
            <!--                        </el-table-column>-->
            <el-table-column
              align="center"
              prop="pay_certificate"
              label="转账回执"
            >
              <template slot-scope="scope">
                <div
                  v-if="scope.row.pay_certificate"
                  v-viewer
                  style="
                    width: 40px;
                    height: 40px;
                    overflow: hidden;
                    cursor: pointer;
                    margin: auto;
                  "
                >
                  <img
                    :src="scope.row.pay_certificate"
                    alt=""
                    style="width: 100%; height: 100%"
                  />
                </div>

                <el-upload
                  :style="'width:100px;float:left;'"
                  class="upload-demo"
                  :show-file-list="false"
                  :action="action"
                  style="display: inline-block; margin-right: 10px"
                  multiple
                  accept="image/*"
                  :on-success="uploadSuccess"
                  with-credentials
                >
                  <el-button
                    v-if="scope.row.status === '1'"
                    type="success"
                    size="mini"
                    @click="setCurrentRow(scope.row)"
                    >上传回执</el-button
                  >
                  <el-button
                    v-if="scope.row.status === '4'"
                    type="primary"
                    plain
                    size="mini"
                    @click="setCurrentRow(scope.row)"
                    >修改回执</el-button
                  >
                </el-upload>
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              prop="status_label"
              label="状态"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="pay_time"
              label="支付时间"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="payer"
              label="支付人"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="pay_err_msg"
              label="转账失败原因"
            ></el-table-column>
          </el-table>
        </div>

        <div v-if="resData" style="text-align: right; padding: 25px">
          <el-pagination
            :current-page.sync="curPage"
            background
            layout="total, prev, pager, next, jumper,sizes "
            :total="resData.total"
            :page-size="form.page_size"
            :page-sizes="[50, 100, 200]"
            @current-change="handleCurrentChange"
            @size-change="handleSizeChange"
          >
          </el-pagination>
        </div>
      </el-col>
    </el-row>
    <div v-if="payVisible">
      <pay-tem
        :ids="multipleSelection"
        :url="urlUpdateStatus"
        :pay_num="pay_num"
        :pay_money="pay_money"
        :props_furinfo="furinfo"
        @onCloseDialog="onCloseDialog"
      ></pay-tem>
    </div>
  </div>
</template>

<script>
import PayTem from "../ykbFlowdetail/PayOrderTem";
import Global_ from "../../components/Global";
import apiBaseURL from "@/utils/baseUrl.js";

export default {
  components: {
    PayTem,
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.fetchData();
    });
  },
  data() {
    return {
      origin: Global_.origin,
      owner_option: [],
      optionsPg: [],
      resData: null,
      form: {
        page_size: 200,
      },
      loading: false,
      tableLoading: false,
      url: "/erp/YkbFlowdetail?order_by[create_time]=desc",
      urlUpdateStatus: "/erp/YkbFlowdetail/updateStatus",
      status: -1,
      curPage: 1,
      filterFold: false,
      pay_num: 0,
      pay_money: 0.0,
      furinfo: "费用",
      payVisible: false,
      multipleSelection: [],
      multipleSelectionInfo: [],
      statusArr: [
        {
          label: "待支付",
          value: 1,
        },
        {
          label: "银行处理中",
          value: 2,
        },
        {
          label: "银行转账失败",
          value: 3,
        },
        {
          label: "支付成功",
          value: 4,
        },
        {
          label: "已作废",
          value: 6,
        },
      ],
      selectedRow: [],
      action: `${apiBaseURL}/erp/Common/erpUploadFile`,
    };
  },
  computed: {
    filteredForm() {
      for (const key in this.form) {
        if (
          this.form[key] === undefined ||
          this.form[key] === "" ||
          this.form[key] === null
        ) {
          delete this.form[key];
        }
      }
      return this.form;
    },
  },
  methods: {
    onCloseDialog(e) {
      this.payVisible = false;
      this.fetchData();
    },
    checkboxInit(row, index) {
      if (row.status != 1 && row.status != 3) return 0;
      // 不可勾选
      return 1; // 可勾选
    },
    defaultDate() {
      const endDate = new Date();
      const endM =
        endDate.getMonth() + 1 < 10
          ? `0${endDate.getMonth() + 1}`
          : endDate.getMonth() + 1;
      const end = `${endDate.getFullYear()}-${endM}-${endDate.getDate()}`;

      const startDate = new Date();
      startDate.setDate(startDate.getDate() - 3);
      const startM =
        startDate.getMonth() + 1 < 10
          ? `0${startDate.getMonth() + 1}`
          : startDate.getMonth() + 1;
      const start = `${startDate.getFullYear()}-${startM}-${startDate.getDate()}`;
      return [start, end];
    },
    output() {
      this.form.is_excel = 1;
      this.$http.get(this.url, { params: this.filteredForm }).then((res) => {
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.form.is_excel = 0;
          if (res.data.code !== 200) {
            this.$message.error(res.data.msg);
          } else {
            window.open(apiBaseURL + res.data.data.file);
          }
        }
      });
    },
    addnew() {
      this.$router.push(`/home/purchasing/orderedit/0`);
    },

    fetchData(showLoading) {
      if (showLoading) {
        this.loading = true;
      }
      this.$http.get(this.url, { params: this.filteredForm }).then((res) => {
        this.loading = false;
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data;
          this.optionsPg = res.data.data.optionsPg;
          this.owner_option = res.data.data.owner_option;
        }
      });
    },
    toggleFilter() {
      this.filterFold = !this.filterFold;
    },
    handleSelectionChange(val) {
      // this.multipleSelection = val;
      this.pay_num = 0;
      this.pay_money = 0.0;
      const multipleSelection = [];
      const multipleSelectionInfo = [];
      for (const key in val) {
        this.pay_num += 1;
        this.pay_money += parseFloat(val[key].amount);
        multipleSelection[key] = val[key].ykb_id;
        multipleSelectionInfo[key] = val[key];
      }
      this.multipleSelection = multipleSelection;
      this.multipleSelectionInfo = multipleSelectionInfo;
    },
    onSubmit() {},
    // 切换页码
    handleCurrentChange(val) {
      this.form.page = val;
      this.tableLoading = true;
      this.$http.get(this.url, { params: this.filteredForm }).then((res) => {
        setTimeout(() => {
          this.tableLoading = false;
        }, 200);
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data;
        }
      });
    },
    handleSizeChange(val) {
      this.form.page_size = val;
      this.fetchData(true);
    },
    handleClick(row) {
      this.$router.push(`/home/purchaseorderdetail/${row.woid}`);
    },
    search() {
      this.form.page = 1;
      this.loading = true;
      this.$http.get(this.url, { params: this.filteredForm }).then((res) => {
        setTimeout(() => {
          this.loading = false;
        }, 200);
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data;
          (this.status = this.filteredForm.status), (this.curPage = 1);
        }
      });
    },
    exportCsv() {
      const exportInfo = {
        flow_title: "标题",
        flow_code: "报销单号",
        submit_time: "报销时间",
        submitter_name: "报销提交人",
        cost_bearing_dept: "费用承担部门",
        legal_entity: "法人实体",
        pay_contact: "收款人",
        pay_bank: "收款银行",
        pay_branch: "支行信息",
        pay_account: "收款人账号",
        amount: "应付金额",
        create_time: "待支付生成日期",
        status_label: "状态",
        pay_time: "支付时间",
        payer: "支付人",
        pay_err_msg: "转账失败原因",
      };

      const paramsArr = { ...this.filteredForm };
      paramsArr.export = JSON.stringify(exportInfo);

      this.$http.get(this.url, { params: paramsArr }).then((res) => {
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          window.open(apiBaseURL + res.data.data.file);
        }
      });
    },
    selectStatus(key) {
      this.loading = true;
      this.form.status = this.status = key;
      this.$http.get(this.url, { params: this.filteredForm }).then((res) => {
        setTimeout(() => {
          this.loading = false;
        }, 200);
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data;
        }
      });
    },
    updateStatus(operationType) {
      if (operationType === "to_valid") {
        if (confirm("确定激活所选中的数据?") === false) {
          return false;
        }
      }
      if (operationType === "to_invalid") {
        if (confirm("确定作废所选中的数据?") === false) {
          return false;
        }
      }

      const statusToBePay = 1;
      const statusBankTransferFail = 3;

      if (this.multipleSelection.length <= 0) {
        this.$message.error("请选择报销单");
        return false;
      }

      if (operationType == "pay") {
        for (const key in this.multipleSelectionInfo) {
          if (this.multipleSelectionInfo[key].status != statusToBePay) {
            this.$message.error("只有待支付状态的数据可以转账支付");
            return false;
          }
        }
        this.payVisible = true;
        return true;
      }
      if (operationType == "to_valid") {
        for (const key in this.multipleSelectionInfo) {
          if (
            this.multipleSelectionInfo[key].status != statusBankTransferFail
          ) {
            this.$message.error("只有转账失败状态的数据可以激活");
            return false;
          }
        }
      } else if ((operationType = "to_invalid")) {
        for (const key in this.multipleSelectionInfo) {
          if (
            this.multipleSelectionInfo[key].status != statusBankTransferFail &&
            this.multipleSelectionInfo[key].status != statusToBePay
          ) {
            this.$message.error("只有待支付状态 和 转账失败状态的数据可以激活");
            return false;
          }
        }
      }

      this.$http
        .put(this.urlUpdateStatus, {
          ykb_ids: this.multipleSelection,
          operation_type: operationType,
        })
        .then((res) => {
          setTimeout(() => {
            this.loading = false;
          }, 200);
          if (res.data.code !== 200) {
            this.$message.error(res.data.msg);
          } else {
            this.$message.success(res.data.msg);
            this.fetchData();
          }
        });
    },
    setCurrentRow(row) {
      this.selectedRow = row;
    },
    uploadSuccess(res) {
      if (res.code !== 200) {
        this.$message.error(res.data.msg);
      } else {
        const img = `${this.origin}/${res.data.files[0]}`;

        this.$http
          .put("/erp/YkbFlowdetail/updatePayCertificate", {
            ykb_id: this.selectedRow.ykb_id,
            certificate_file: img,
          })
          .then((res) => {
            setTimeout(() => {
              this.loading = false;
            }, 200);
            if (res.data.code !== 200) {
              this.$message.error(res.data.msg);
            } else {
              this.$message.success(res.data.msg);
              this.fetchData();
              // this.selectedRow.pay_certificate = img;
            }
          });
      }
    },
  },
};
</script>

<style scoped>
.row {
  height: 60px;
}

.column {
  text-align: center;
  border: 1 px solid #ddd;
  font-size: 12px;
}

.data-statics {
  background: #f3f3f3;
  height: 40px;
  font-size: 14px;
  color: #333;
  line-height: 40px;
  padding: 0 25px;
}

.filter {
  border: 1px solid #ddd;
}

.el-row {
  margin-bottom: 20px;
}

.el-row:last-child {
  margin-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/ykbFlowdetail/YkbFlowdetailList.vue